import React from 'react';
import { Event } from '../../../../../model/event';
import { Card } from '../../../../../components/Card/Card';
import { Seatmap } from '../../../../../components/Seatmap/Seatmap';
import { PrintSeatTicketOverlay } from './print_seat_ticket_overlay';
import { Effect } from '../../../../../components/Effect/Effect';
import { PrintSectionTicketOverlay } from './print_section_ticket_overlay';
import { t } from '../../../../../locales/translate';
import { allSeatsEditable } from '../../../../../model/contingent';

interface Props {
  event: Event;
  onTicketsCreated: (info: { generalSectionIds: Array<string>; seated: boolean }) => Promise<void>;
}

export function PrintPlan({ event, onTicketsCreated }: Props): JSX.Element {
  const layoutId = event.venueLayout?.id;
  if (!layoutId) return <div>error: missing venue layout id</div>;
  return (
    <Card title={t.model.contingent.generateFreeTickets}>
      <p>{t.model.ticket.selectFreeSeats}</p>
      <Seatmap layoutId={layoutId} eventId={event.id} mode="allocation">
        {({ seatmap }) => (
          <>
            <Effect effect="pop">
              {seatmap.selection.seats.size > 0 && allSeatsEditable(Array.from(seatmap.selection.seats)) && (
                <PrintSeatTicketOverlay
                  event={event}
                  seats={Array.from(seatmap.selection.seats)}
                  onTicketsCreated={async () => {
                    await Promise.all([
                      onTicketsCreated({ generalSectionIds: [], seated: true }),
                      seatmap.reloadSeatStatus(),
                    ]);
                  }}
                  onClose={() => seatmap.selection.clear()}
                />
              )}
            </Effect>
            <Effect effect="pop">
              {seatmap.selection.section && (
                <Card size="xs" title={seatmap.selection.section.name}>
                  <PrintSectionTicketOverlay
                    event={event}
                    section={seatmap.selection.section}
                    onTicketsCreated={async ({ sectionId }) => {
                      await Promise.all([
                        onTicketsCreated({ generalSectionIds: [sectionId], seated: false }),
                        seatmap.reloadAllocation(),
                      ]);
                    }}
                    onClose={() => seatmap.selection.clear()}
                  />
                </Card>
              )}
            </Effect>
          </>
        )}
      </Seatmap>
    </Card>
  );
}
